<template>
  <div class="reader_allpage">
    <div class="contrainer">
      <div class="search">
        <!-- @keyup.enter.native="currentPageSearch" -->
        <!-- <el-input placeholder="关键词动态查询" v-model='keyword'>
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input> -->
      </div>
      <div class="result_wrap">
        <div class="result">
          <!-- <div class="title">曹月川先生遗书曹月川先生遗书曹月川先生遗书</div> -->
          <div class="content">
            <p v-for="(item, index) in catalogList" :key="index" @click="changePage(item.beginPage)">{{ item.catalogName
              }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { catalogList } from '@/api/api'
export default {
  data () {
    return {
      keyword: '',
      catalogList: []
    }
  },
  mounted () {
    this.getCatalogList()
  },
  methods: {
    changePage (val) {
      if (val > this.data.length) {
        this.$message({
          message: '页码超出范围',
          type: 'warning'
        })
        return false
      }
      this.$emit('changePage', val)
    },
    getCatalogList () {
      const bookId = this.$route.query.bookId
      catalogList({
        parentId: 0,
        bookId
      }).then(res => {
        if (res.code === 200) {
          this.catalogList = res.data
        } else {
          this.catalogList = []
        }
        this.$emit('getCatalog', this.catalogList)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.reader_allpage {
  height: 100%;
  overflow: auto;

  .contrainer {
    .search {
      padding: 18px 20px 14px 20px;
    }

    .result_wrap {
      .result{
        margin-bottom: 10px;
        &:last-child{
          margin-bottom: 0;
        }
      }

      .title {
        display: flex;
        width: 100%;
        height: 28px;
        line-height: 28px;
        background: #F5F5F5;
        color: #333333;
        padding: 0 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        font-weight: 700;
        font-size: 14px;
        img{
          display: inline-block;
          width: 16px;
          height: 16px;
        }
      }

      .content {
        p {
          padding: 0 20px 0 44px;
          font-size: 14px;
          line-height: 14px;
          margin-top: 12px;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/components/catalog.vue